import { DataSource, Layout, Table} from "@mcleod/components";

export abstract class AutogenLayoutOrderImages extends Layout {
	sourceOrderImages: DataSource;
	tableImages: Table;
}
